"use client";

import styles from "./AuthorizeAuthenticationForm.module.scss";
import classNames from "classnames";

import { useGoogleAuth } from "@/hooks";
import { createForm } from "@/stores";
import { useEffect } from "react";

import {
  AuthorizeRememberMeCheckbox,
  AuthorizeForgotPasswordLink,
  AuthorizePasswordInput,
  AuthorizeEmailInput,
  AuthorizeSubmitButton,
  AuthorizeGoogleButton,
} from "..";
import { useAuthorizeForm } from "../../_hooks";
import { Flex } from "@vetty/ui";

/**
 * AuthorizeAuthenticationForm Component
 *
 * Complete authentication form with Google OAuth and email/password authorize.
 * Handles form initialization, loading states, and user authentication flow.
 */
export const AuthorizeAuthenticationForm = () => {
  // Google OAuth state for loading management
  const googleAuthState = useGoogleAuth();
  const { authError } = useAuthorizeForm();

  // Initialize form with required fields
  useEffect(() => {
    createForm(["email", "password"]);
  }, []);

  return (
    <Flex direction={"column"} className={styles["comp"]}>
      {/* Google OAuth authentication */}
      <AuthorizeGoogleButton />

      {/* Visual separator between auth methods */}
      <Flex className={styles["comp__or"]} align={"center"} gap={8}>
        <div className={styles["comp__or__line"]}></div>
        <div className={styles["comp__or__label"]}>OR</div>
        <div className={styles["comp__or__line"]}></div>
      </Flex>

      {/* Email/password form section */}
      <Flex
        direction={"column"}
        className={classNames(
          styles["comp__content"],
          googleAuthState.loading && styles["comp__content--disabled"]
        )}
      >
        <Flex direction={"column"} gap={40} className={styles["comp__form"]}>
          {/* Error message */}
          {authError && (
            <div
              style={{
                fontSize: "16px",
                color: "#ef4444",
                textAlign: "center",
                background: "#fee2e2",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #fecaca",
              }}
            >
              {authError}
            </div>
          )}

          {/* Form inputs section */}
          <Flex direction={"column"} gap={24}>
            {/* Email and password inputs */}
            <AuthorizeEmailInput />
            <AuthorizePasswordInput />

            {/* Form options row */}
            <Flex justify={"space-between"} align={"center"}>
              <AuthorizeRememberMeCheckbox />
              <AuthorizeForgotPasswordLink />
            </Flex>

            {/* Submit button */}
            <AuthorizeSubmitButton />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
